import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Button } from '@sopranodesign/pulse-components';

const TicketScope = ({ content }) => {
  return (
    <Button variant="inline" as={Link} to={`/tickets/${content.id}`}>
      {content.name}
    </Button>
  );
};

TicketScope.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default TicketScope;
